import React, { useContext, useEffect, useMemo, useState } from "react";
import Navbar from "../../../../common/layout/Navbar";
import { Title } from "../../../../../stories/Title/Title";
import {
  empType,
  LicenseTypes,
  Operation,
} from "../../../../../utils/Enum.types";
import { optionsType, responseType } from "../../../../../utils/formTypes";
import EmplayeeSelect from "../../../../../customComponents/EmplayeeSelect";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  EMPTY_STRING,
  ROWS_PER_PAGE,
  emptyFunc,
  emptyMessage,
} from "../../../../../utils/constants";

import useUrlParams from "../../../../../customHooks/useUrlParams";
import { OrderDirection, nodeVar } from "../../../../../utils/commonQueryTypes";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../../stories/Button/Button";
import { AddUserRights, UpdateUserRights } from "./queries/mutations";
import {
  AddUserRightsResult,
  AddUserRightsVar,
  GetUserRightsByEmpIdResult,
  GetUserRightsByEmpIdVar,
  UpdateUserRightsResult,
  UpdateUserRightsVar,
  UserRightsDetails,
  UserRightsMasterOrderField,
} from "./queries/types";
import { EmpMaster, EmpQueryType } from "../queries/types";
import {
  GetEmployee,
  GetUserRights,
  GetUserRightsByEmpId,
} from "./queries/queries";
import MessageModal from "../../../../../customComponents/MessageModal";
import {
  LabeledAutocomplete,
  labelClasses,
} from "../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../utils/Enum.keys";
import LoadingModal from "../../../../pages/LoadingModal";
import useLabels from "../../../../../customHooks/useLabels";
import CompanySelect from "../../../../../customComponents/CompanySelect";
import SubsidiarySelect from "../../../../../customComponents/SubsidiarySelect";
import SiteSelect from "../../../../../customComponents/SiteSelect";
import { AppContext } from "../../../../../context/context";
import { payloadTypes } from "../../../../../context/reducer";
import CompaniesList from "./CompaniesList";
import SubsidiariesList from "./SubsidiariesList";
import SitesList from "./SitesList";
import JunctionsList from "./JunctionsList";
import { handleMUISelectEvent } from "../../../../../utils/UtilFunctions";
import DataFetch from "../../../../../images/OpenIcon.svg";
import Modal from "react-modal";
import { AddModalStyles } from "../../../../../styles/CustomModalStyles";
import AssignedList from "./Index";
import UsersList from "../Index";
import { TableType } from "../../../customer/companies/queries/types";

const AssignRights = () => {
  const navigate = useNavigate();
 
  const { customer_id, company_id, user_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const { state, dispatch } = useContext(AppContext);
  const [message, setMessage] = useState(emptyMessage);
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [modalFlag, setModalFlag] = useState(false);
  const [empDetails, setEmpDetails] = useState({
    empId: 0,
    name: "",
    category: "",
  });

  const [accessTableLevel, setAccessTableLevel] = useState<TableType>(
    TableType.JUNCTION
  );

  const [getEmployee, { loading: GetEmployeeLoading }] = useLazyQuery<
    { node: EmpMaster },
    nodeVar
  >(GetEmployee);

  const [addUserRights, { loading: AddUserRightsLoading }] = useMutation<
    AddUserRightsResult,
    AddUserRightsVar
  >(AddUserRights, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [updateUserRights, { loading: UpdateUserRightsLoading }] = useMutation<
    UpdateUserRightsResult,
    UpdateUserRightsVar
  >(UpdateUserRights, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [
    getUserRightsByEmpId,
    { data: getUserRightsByEmpIdData, loading: getUserRightsByEmpIdLoading },
  ] = useLazyQuery<GetUserRightsByEmpIdResult, GetUserRightsByEmpIdVar>(
    GetUserRightsByEmpId
  );

  const { companyLabel, junctionLabel, subsidiaryLabel, subsidiarySiteLabel } =
    useLabels();

  const tableLevelOptions = useMemo(() => {
    return [
      {
        label: `${companyLabel}`,
        value: TableType.COMPANY,
      },
      {
        label: `${subsidiaryLabel}`,
        value: TableType.SUBSIDIARY,
      },
      {
        label: `${subsidiarySiteLabel}`,
        value: TableType.SITE,
      },
      {
        label: `${junctionLabel}`,
        value: TableType.JUNCTION,
      },
    ];
  }, [companyLabel, junctionLabel, subsidiaryLabel, subsidiarySiteLabel]);

  const handleCheckboxChange = (id: number) => {
    setSelectedIds(
      (prevSelected) =>
        prevSelected.includes(id)
          ? prevSelected.filter((itemId) => itemId !== id) // Remove if already selected
          : [...prevSelected, id] // Add if not selected
    );
  };

  const HandleSubmit = async () => {
    if ( customer_id && accessTableLevel && selectedIds.length) {
      if (user_id) {
        updateUserRights({
          variables: {
            
            customerID: customer_id,
            user_details,
            empID: user_id ? user_id : empDetails.empId,
            input: {
              ids: selectedIds,
              tableLevel: accessTableLevel,
            },
          },
          refetchQueries: [
            {
              query: GetUserRights,
              variables: {
                
                customerID: customer_id,
                after: null,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: UserRightsMasterOrderField.EMP_ID,
                },
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.UpdateUserRights) {
            setMessage({
              flag: true,
              message: "Updated successfully",
              operation: Operation.UPDATE,
            });
            setSelectedIds([]);
          }
        });
      } else {
        addUserRights({
          variables: {
            
            customerID: customer_id,
            user_details,
            empID: user_id ? user_id : empDetails.empId,
            input: {
              ids: selectedIds,
              tableLevel: accessTableLevel,
            },
          },
          refetchQueries: [
            {
              query: GetUserRights,
              variables: {
                
                customerID: customer_id,
                after: null,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: UserRightsMasterOrderField.EMP_ID,
                },
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.AddUserRights) {
            setMessage({
              flag: true,
              message: "Added successfully",
              operation: Operation.CREATE,
            });
            dispatch({
              type: payloadTypes.SET_COMPANY_ID,
              payload: {
                companyId: 0,
              },
            });
            dispatch({
              type: payloadTypes.SET_SUB_ID,
              payload: {
                subsidiaryId: 0,
              },
            });
            dispatch({
              type: payloadTypes.SET_SUB_SITE_ID,
              payload: {
                subSiteId: 0,
              },
            });
            setSelectedIds([]);
          }
        });
      }
    }
  };

  useEffect(() => {
    if (state.empId)
      getEmployee({
        variables: {
          id: state.empId,
          
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setEmpDetails({
            empId: data.node.id,
            name: data.node.name,
            category: data.node.empType,
          });
          dispatch({
            type: payloadTypes.SET_COMPANY_ID,
            payload: {
              companyId: data.node.companyID,
            },
          });
          dispatch({
            type: payloadTypes.SET_SUB_ID,
            payload: {
              subsidiaryId: data.node.subsidiaryID,
            },
          });
          dispatch({
            type: payloadTypes.SET_SUB_SITE_ID,
            payload: {
              subSiteId: data.node.siteID,
            },
          });
        }
      });
  }, [getEmployee, state.empId]);

  useEffect(() => {
    if ((user_id || state.empId) && customer_id)
      getUserRightsByEmpId({
        variables: {
          
          customerID: customer_id ? customer_id : 0,
          empID: user_id ? user_id : state.empId ? state.empId : 0,
        },
      }).then(({ data }) => {
        if (data && data.GetUserRightsByEmpId) {
          let userRights = data.GetUserRightsByEmpId;
          setEmpDetails({
            empId: userRights.empDetails.id,
            name: userRights.empDetails.name,
            category: userRights.empDetails.empType,
          });

          dispatch({
            type: payloadTypes.SET_COMPANY_ID,
            payload: {
              companyId: userRights.empDetails.companyID,
            },
          });
          dispatch({
            type: payloadTypes.SET_SUB_ID,
            payload: {
              subsidiaryId: userRights.empDetails.subsidiaryID,
            },
          });
          dispatch({
            type: payloadTypes.SET_SUB_SITE_ID,
            payload: {
              subSiteId: userRights.empDetails.siteID,
            },
          });

          setAccessTableLevel(userRights.tableLevel as TableType);
        }
      });
  }, [getUserRightsByEmpId, user_id, state.empId,customer_id]);

  useEffect(() => {
    const userRights = getUserRightsByEmpIdData?.GetUserRightsByEmpId;
    if (userRights && userRights.tableLevel === accessTableLevel) {
      if (userRights.tableLevel === TableType.COMPANY) {
        setSelectedIds(
          userRights.rightsDetails.map((node, index) => node.companyID)
        );
      } else if (userRights.tableLevel === TableType.SUBSIDIARY) {
        setSelectedIds(
          userRights.rightsDetails.map((node, index) => node.subsidiaryID)
        );
      } else if (userRights.tableLevel === TableType.SITE) {
        setSelectedIds(
          userRights.rightsDetails.map((node, index) => {
            return node.siteID;
          })
        );
      } else if (userRights.tableLevel === TableType.JUNCTION) {
        setSelectedIds(
          userRights.rightsDetails.map((node, index) => node.junctionID)
        );
      }
    } else {
      setSelectedIds([]);
    }
  }, [getUserRightsByEmpIdData, accessTableLevel]);

  const handleClose = () => {
    setMessage({
      message: "",
      flag: false,
      operation: Operation.NONE,
    });
  };

  const getName = (node: UserRightsDetails) => {
    if (getUserRightsByEmpIdData) {
      switch (getUserRightsByEmpIdData.GetUserRightsByEmpId.tableLevel) {
        case TableType.COMPANY:
          return node.company.name;
        case TableType.SUBSIDIARY:
          return node.subsidiaryDetails.name;
        case TableType.SITE:
          return node.siteDetails.name;
        case TableType.JUNCTION:
          return node.junctionDetails.name;
      }
    } else {
      return EMPTY_STRING;
    }
  };

  return (
    <>
      <Navbar NavType={LicenseTypes.CUSTOMER_USERS} />

      <Title>User Rights Configurations</Title>
      <div className="assign-user-rights">
        <div className="row g-0 assign-user-rights__select-options">
          <div className="col-4">
            {user_id ? (
              <TextField
                label="Employee Name"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                disabled
                value={empDetails.name}
                className="assign-user-rights__textfield"
              />
            ) : (
              <div className="d-flex">
                <EmplayeeSelect
                  label="Employee Name"
                  onChange={(newValue) => {
                    if (newValue) {
                      dispatch({
                        type: payloadTypes.SET_EMP_ID,
                        payload: {
                          empId: newValue.value,
                        },
                      });
                    } else {
                      dispatch({
                        type: payloadTypes.SET_EMP_ID,
                        payload: {
                          empId: 0,
                        },
                      });
                    }
                  }}
                  onKeyDown={() => {}}
                  value={state.empId ? state.empId : 0}
                  empType={[empType.ACP]}
                  queryType={EmpQueryType.OTHER_THAN_SYS_ADMIN}
                />
                <img
                  src={DataFetch}
                  alt=""
                  onClick={() => setModalFlag(!modalFlag)}
                  className="data-fetch-icon"
                />
              </div>
            )}
            <div>
              <LabeledAutocomplete
                className={labelClasses.inputRoot}
                onKeyDown={(e) => {
                  if (e.key === Keys.ENTER) {
                    e.preventDefault();
                    handleMUISelectEvent(e);
                  }
                }}
                options={tableLevelOptions}
                value={accessTableLevel}
                openOnFocus
                forcePopupIcon
                freeSolo
                onChange={(e, newValue) => {
                  if (newValue) {
                    setAccessTableLevel(
                      (newValue as optionsType).value as TableType
                    );
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    className={labelClasses.formControlRoot}
                    label={"Access Levels"}
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                )}
              />
            </div>
          </div>
          <div className="col-4">
            {accessTableLevel === TableType.SUBSIDIARY ||
            accessTableLevel === TableType.SITE ||
            accessTableLevel === TableType.JUNCTION ? (
              <CompanySelect
                label="Company Name"
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_COMPANY_ID,
                      payload: {
                        companyId: newValue.value,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_COMPANY_ID,
                      payload: {
                        companyId: 0,
                      },
                    });
                  }
                }}
                onKeyDown={() => {}}
                value={state.companyId ? state.companyId : 0}
              />
            ) : (
              ""
            )}
            {accessTableLevel === TableType.SITE ||
            accessTableLevel === TableType.JUNCTION ? (
              <SubsidiarySelect
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_SUB_ID,
                      payload: {
                        subsidiaryId: newValue.node.id,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_SUB_ID,
                      payload: {
                        subsidiaryId: 0,
                      },
                    });
                  }
                }}
                label={"Subsidiary"}
                companyID={state.companyId ? state.companyId : 0}
                onKeyDown={emptyFunc}
                value={state.subsidiaryId ? state.subsidiaryId : 0}
              />
            ) : (
              ""
            )}

            {accessTableLevel === TableType.JUNCTION ? (
              <SiteSelect
                label="Site Name"
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_SUB_SITE_ID,
                      payload: {
                        subSiteId: newValue.value,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_SUB_SITE_ID,
                      payload: {
                        subSiteId: 0,
                      },
                    });
                  }
                }}
                companyId={state.companyId ? state.companyId : 0}
                subsidiaryId={state.subsidiaryId ? state.subsidiaryId : 0}
                onKeyDown={() => {}}
                value={state.subSiteId ? state.subSiteId : 0}
              />
            ) : (
              ""
            )}
          </div>
          <div className="col ">
            <div>
              <TextField
                label="Name."
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                disabled
                value={empDetails.name}
                className="assign-user-rights__textfield"
              />

              <TextField
                label="Type."
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                value={empDetails.category}
                className="assign-user-rights__textfield"
                disabled
              />
            </div>
          </div>
        </div>
        <div className="row g-0 assign-user-rights__datablock">
          <div className="col assign-user-rights__datablock--left">
            <div className="assign-user-rights__tableblock">
              {accessTableLevel === TableType.COMPANY ? (
                <CompaniesList
                  handleCheckboxChange={handleCheckboxChange}
                  selectedIds={selectedIds}
                />
              ) : accessTableLevel === TableType.SUBSIDIARY &&
                state.companyId ? (
                <SubsidiariesList
                  handleCheckboxChange={handleCheckboxChange}
                  selectedIds={selectedIds}
                />
              ) : accessTableLevel === TableType.SITE &&
                state.companyId &&
                state.subsidiaryId ? (
                <SitesList
                  handleCheckboxChange={handleCheckboxChange}
                  selectedIds={selectedIds}
                />
              ) : accessTableLevel === TableType.JUNCTION &&
                state.companyId &&
                state.subsidiaryId &&
                state.subSiteId ? (
                <JunctionsList
                  handleCheckboxChange={handleCheckboxChange}
                  selectedIds={selectedIds}
                />
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="col assign-user-rights__datablock--right">
          <Title>Selected</Title>
            <div className="assign-user-rights__tableblock">
            <TableContainer className="import-excel-data__datablock--table">
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell id="td-center">Sl</TableCell>
                    <TableCell id="td-center">Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getUserRightsByEmpIdData &&
                    getUserRightsByEmpIdData.GetUserRightsByEmpId.rightsDetails.map(
                      (node, index) => {
                        return (
                          <TableRow key={index}>
                            <TableCell id="td-center">{index + 1}</TableCell>
                            <TableCell id="td-center">
                              {getName(node)}
                            </TableCell>
                          </TableRow>
                        );
                      }
                    )}
                </TableBody>
              </Table>
            </TableContainer>
            </div>
           
          </div>
        </div>
        <Button mode="save" onClick={HandleSubmit} />

        <Button
          mode="back"
          onClick={() => {
            navigate(-1);
          }}
        />
      </div>

      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />

      <LoadingModal
        flag={
          AddUserRightsLoading ||
          getUserRightsByEmpIdLoading ||
          GetEmployeeLoading ||
          UpdateUserRightsLoading
        }
      />

      <Modal isOpen={modalFlag} ariaHideApp={false} style={AddModalStyles}>
        <UsersList setModalFlag={setModalFlag} modalFlag={modalFlag} />
      </Modal>
    </>
  );
};

export default AssignRights;
